var map = {
	"./audio.png": "ba25",
	"./close.svg": "0718",
	"./close_black.svg": "2cb8",
	"./excel.png": "96c8",
	"./file.png": "373b",
	"./loading.svg": "fb33",
	"./minus.svg": "9492",
	"./minus_black.svg": "e768",
	"./pdf.png": "0017",
	"./ppt.png": "9bdd6",
	"./send.svg": "3935",
	"./send_fail.svg": "6e61",
	"./send_succ.svg": "811d",
	"./to_kf.svg": "630e",
	"./to_kf_black.svg": "06da",
	"./to_robot.svg": "2739",
	"./video.png": "1274",
	"./word.png": "c9a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "43a5";